import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import ColorProvider from "./comoponents/templates/ColorProvider"
import { StoreProvider } from "./store"

ReactDOM.render(
  <React.StrictMode>
    <StoreProvider>
      <ColorProvider>
        <App />
      </ColorProvider>
    </StoreProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
